'use client';
import React, { FC } from 'react';

import Image from '@/components/core/Image';
import Share, { ShareIconProps } from '@/components/core/Share';
import { useTranslation } from '@/hooks/useTranslations';
import mailImg from '@/public/assets/Images/mail.png';

import AddressInfo from './AddressInfo';

import './styles.scss';

const socialIcons: ShareIconProps[] = [
  { name: 'facebook', link: 'https://facebook.com/PopOkGamingOfficial' },
  { name: 'instagram', link: 'https://instagram.com/popokgamingofficial' },
  {
    name: 'linkedin',
    link: 'https://linkedin.com/company/77980107/admin/dashboard/',
  },
  { name: 'youtube', link: 'https://youtube.com/@PopOK_Gaming' },
  { name: 'x', link: 'https://x.com/popok_gaming' },
];

const OurAddresses: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="ourAddress">
      <div className="ourAddressHeaderGroup">
        <h2 className="ourAddressHeader">{t('Contactus-OurAddresses-Title')}</h2>
        <p className="ourAddressInfoDesc">{t('Contactus-OurAdresses-Paragraph')}</p>
      </div>
      <div className="ourAddressGroup">
        <AddressInfo
          icon="bc-i-address AddressBlockIcon"
          title="Contactus-Address-SubTitle"
          description={
            <address className="ourAddressInfoDesc">{t('Contactus-Address-Location')}</address>
          }
        />
        <AddressInfo
          icon="bc-i-email AddressBlockIcon"
          title="Contactus-Addess-SalesEmail-Title"
          description={
            <a className="ourAddressInfoDesc" href="mailto:sales@popokgaming.com">
              sales@popokgaming.com
            </a>
          }
        />
        <AddressInfo
          icon="bc-i-email AddressBlockIcon"
          title={t('Contactus-Address-GeneralEmail-Title')}
          description={
            <a className="ourAddressInfoDesc" href="mailto:support@popokgaming.com">
              support@popokgaming.com
            </a>
          }
        />
      </div>
      <Share.Group socialLinks={socialIcons} />
      <div className="ouraddressImageGroup">
        <div className="ouraddressImage">
          <Image src={mailImg} alt="mail" className="addressImage" />
        </div>
      </div>
    </div>
  );
};

export default OurAddresses;
